/* eslint-disable react/prop-types */
import React from 'react';
import { HtmlSafe } from 'polaris-coreweb/exports';

import { TeamHub } from 'Components/molecules/TeamHub';

import 'Styles/components/molecules/_TeamHub.scss';

export const getContributors = ({ contributors, title = 'Contributors' }) => {
  const mappedContributors = contributors.map(contributor => ({
    title: [contributor.jobTitle || '', contributor.company || ''].filter(item => item).join(', '),
    name: contributor.name || '',
    url: contributor.url || '',
    hasNameAsLink: (!!contributor.url),
    bio: (<HtmlSafe html={contributor.shortBio || ''} />),
  }));

  const isContributorDisclaimerExist = contributors && Array.isArray(contributors) && contributors.length && contributors[0].disclaimer;
  const contributorLegal = isContributorDisclaimerExist ? (<HtmlSafe html={contributors[0].disclaimer} />) : '';

  return (
    <div className="polaris__simple-grid--main">
      <TeamHub
        title={title}
        linkLabel=""
        titlePosition="after-name"
        content={mappedContributors}
        summary={contributorLegal}
      />
    </div>
  );
};
